import React from 'react';
import { DateTime } from 'luxon';
import UPCode from '../../../components/UPcode';
import SideBar from '../../Common/SideBar';
import { TextsmsOutlined } from '@material-ui/icons';
import './Poll.scss';
const PollOption = ({
  option,
  accent_color,
  totalVotes,
  body_color,
  body_font_family
}) => {
  const percentage = totalVotes > 0 ? Math.round(option.votes / totalVotes * 100) : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "poll-option"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-option-label-percentage-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-option-label",
    style: {
      color: body_color,
      fontFamily: body_font_family
    }
  }, option.label), /*#__PURE__*/React.createElement("div", {
    className: "poll-option-percentage",
    style: {
      color: body_color,
      fontFamily: body_font_family
    }
  }, percentage, "%")), /*#__PURE__*/React.createElement("div", {
    className: "poll-option-bar-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-option-bar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-option-bar",
    style: {
      width: `${percentage}%`,
      backgroundColor: accent_color
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "poll-option-bar-empty"
  }))));
};
const Poll = props => {
  const {
    data,
    metadata,
    text,
    bohStyle,
    deviceId,
    organizationId,
    tracking,
    properties
  } = props;
  const {
    accent_color,
    title_color,
    title_font_family,
    text_accent_color,
    body_color,
    body_font_family,
    containerStyle
  } = bohStyle;
  const question = (data === null || data === void 0 ? void 0 : data.question) || '';
  const options = (data === null || data === void 0 ? void 0 : data.options) || [];
  const lastUpdated = data === null || data === void 0 ? void 0 : data.last_updated;
  const expiresAt = data === null || data === void 0 ? void 0 : data.expires_at;
  const timezone = (data === null || data === void 0 ? void 0 : data.timezone) || 'UTC';
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const totalVotes = options.reduce((sum, option) => sum + (option.votes || 0), 0);
  const isExpired = expiresAt ? DateTime.fromISO(expiresAt) < DateTime.now() : false;
  let lastUpdatedFormatted = '';
  if (lastUpdated) {
    try {
      const lastUpdatedDate = DateTime.fromISO(lastUpdated, {
        zone: timezone
      }).setLocale('en-US');
      lastUpdatedFormatted = lastUpdatedDate.toFormat('MM/dd/yyyy HH:mm');
    } catch (e) {
      lastUpdatedFormatted = '';
    }
  }
  const showQR = !isExpired && tracking;
  return /*#__PURE__*/React.createElement("div", {
    className: "poll-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-results-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poll-badge",
    style: {
      backgroundColor: accent_color
    }
  }, /*#__PURE__*/React.createElement(TextsmsOutlined, null), /*#__PURE__*/React.createElement("span", {
    className: "poll-badge-text"
  }, "QUICK POLL")), /*#__PURE__*/React.createElement("div", {
    className: "poll-question",
    style: {
      color: title_color,
      fontFamily: title_font_family
    }
  }, question), /*#__PURE__*/React.createElement("div", {
    className: "poll-options"
  }, options.map((option, index) => /*#__PURE__*/React.createElement(PollOption, {
    key: `option-${index}`,
    option: option,
    accent_color: accent_color,
    totalVotes: totalVotes,
    body_color: body_color,
    body_font_family: body_font_family
  }))), lastUpdatedFormatted && /*#__PURE__*/React.createElement("div", {
    className: "poll-last-updated",
    style: {
      color: body_color,
      fontFamily: body_font_family
    }
  }, "Last Updated: ", lastUpdatedFormatted)), showQR ? /*#__PURE__*/React.createElement(UPCode, {
    properties: properties,
    tracking: {
      ...tracking,
      logo: metadata.logo
    },
    playing: true,
    clickable: false,
    rightPanelBackgroundColor: accent_color,
    UPcodeBackground: "#FFFFFF",
    size: 376,
    deviceId: deviceId,
    organizationId: organizationId,
    showShortURL: false
  }) : /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: isExpired ? 'This poll has expired.' : (text === null || text === void 0 ? void 0 : text.message_board) || '',
    fontFamily: title_font_family,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default Poll;